// react
import React, { useContext} from 'react';
import useForm from 'react-hook-form';
import moment from "moment";
import ReactTable from "react-table";
import CsvDownloader from 'react-csv-downloader';
import { useTranslation } from 'react-i18next';
import Datetime from "react-datetime";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Search_Icon from "@material-ui/icons/Search";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";

// services
import { validateDate, convertDate, formateDate, transformValueFloattoFormated, getLocale, getStringFormatDate } from "beaktShared/helpers/masks";
import { UsePostApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);

export default function RelatorioVendaByAtendente() {

    // Padrão para Todas as Telas
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const { register, setValue, errors, setError, clearError, getValues } = useForm({mode: "onBlur"});

    // Elementos de LayOut
    const classes = useStyles();
    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };
    
    // Filtros
    const [dtini, setdtini] = React.useState(formateDate(moment(new Date()).add(-1, 'months')));
    const [dtfim, setdtfim] = React.useState(formateDate(moment(new Date())));    

    const monthDiff = (dateFrom, dateTo) => {
        return dateTo.getMonth() - dateFrom.getMonth() + 
        (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
    }
    
    // Ações 
    const handleClickPesquisa = () =>{
        let data = getValues();
                
        if(data.dtini === "")
        {
            setError("dtini","required", t('label.required'))
            return false;
        }
        else
            clearError("dtini")
        
        if(data.dtfim === "")
        {
            setError("dtfim","required", t('label.required'))
            return false;
        }
        else
            clearError("dtfim")
        
        if (!validateDate(data.dtini)) {
            setError("dtini", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtini")
        
        if (!validateDate(data.dtfim)) {
            setError("dtfim", "invaliddate",  t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtfim")
        
        var dataIniConvertida = convertDate(data.dtini);
        var dataFimConvertida = convertDate(data.dtfim);
        
        if(monthDiff(dataIniConvertida,dataFimConvertida) > 3){            
            showNotification(t('error_message.select_3month'), 'danger')
            return false; 
        }        

        let obj = {            
            dataIni:dataIniConvertida,
            dataFim:dataFimConvertida
        }

        loadDados(obj);
    };

    // *******************************************************************************
    // ************************ CARREGAR ITENS DA LISTA ******************************
    // *******************************************************************************

    const [list, setlist] = React.useState([]);
    const [isLoadingList, setisLoadingList] = React.useState(false);

    const loadDados = (obj) =>{ 
        setisLoadingList(true);       
        const endPoint = "relatorios/relmidiaxvendas/" + session.estabelecimentoId + "/" + session.franquiaId;
        UsePostApi(endPoint,obj).then(result=>{    
            if(result.status !== 200)
            {   
                showNotification(result.message, 'danger')
                setisLoadingList(false);
                return false; 
            }                
            setlist(result.data);
            loadDataCsv(result.data);
            setisLoadingList(false);   
            return true;                
        });  
    }

    // *******************************************************************************
    // ************************** CARREGAR ITENS DO CSV ******************************
    // *******************************************************************************
     
    const [dataCSV,setdataCSV] = React.useState([]);  
    
    const loadDataCsv = (data) =>{
        let dtCsv = [];

        data.map(item =>{
            var obj = {
                midia: item.midia,
                qtdAvaliacao: item.qtdAvaliacao,
                qtdContrato: item.qtdContrato,
                totalContrato: "R$ " + item.totalContrato.toString().replace('.',','),
            };
            dtCsv.push(obj);
        })

        setdataCSV(dtCsv);
    } 

    // *******************************************************************************
    // ********************************** CABEÇALHO CSV **********************************
    // *******************************************************************************

    const columnsCSV = [
        { displayName: "Mídia", id: "midia" },
        { displayName: "Qtd Avaliações", id: "qtdAvaliacao" },
        { displayName: "Qtd Contratos", id: "qtdContrato" },
        { displayName: "Total Contratos", id: "totalContrato" },
    ];

    // *******************************************************************************
    // *************************** PROPRIEDADES CABEÇALHO TELA****************************
    // *******************************************************************************

    const columnsProp = 
    [
        {
            Header: t('label.midia_channel'),
            filterable: false,
            accessor: "midia",        
        },
        {
            Header: t('label.evaluation_quantity'),
            filterable: false,
            accessor: "qtdAvaliacao",        
        },
        {
            Header: t('label.contract_quantity'),
            filterable: false,
            accessor: "qtdContrato",
        },
        {
            Header: t('label.total_contracts'),
            filterable: false,
            accessor: "totalContrato",
            Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div>
        }
    ];
    
    const columns = [...columnsProp];


    return (
            
        <div>

            {/* PESQUISA */}
            <GridContainer>            
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Search_Icon />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>
                                {t('label.research')}
                            </h4>
                        </CardHeader>
                        <CardBody>
                        <GridContainer>      
                            <GridItem xs={12} sm={6} md={3}>   
                                <FormControl fullWidth className={classes.formControl}>                                                               
                                    <label className={errors.dtini?"select__label select__label_error":"select__label"}>
                                        {t('label.ini_date')+" *"}  </label>
                                    <Datetime                                    
                                        locale={getLocale()}
                                        dateFormat={getStringFormatDate()}
                                        timeFormat={false}                                    
                                        name="dtini"                                      
                                        defaultValue={dtini}
                                        value={dtini}
                                        onChange={date => { setdtini(date) }}
                                        inputProps={{name:"dtini", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                        className={errors.dtini?"error":""}            
                                    />       
                                    {errors.dtini && <FormHelperText className={classes.labelRootError}>
                                        <span> {errors.dtini.message} </span>                                                                          
                                    </FormHelperText>} 
                                </FormControl>                                 
                            </GridItem>
                            <GridItem xs={12} sm={6} md={3}>
                                <FormControl fullWidth className={classes.formControl}>                                                               
                                    <label className={errors.dtfim?"select__label select__label_error":"select__label"}>
                                        {t('label.end_date')+" *"}  </label>
                                    <Datetime                                    
                                        locale={getLocale()}
                                        dateFormat={getStringFormatDate()}
                                        timeFormat={false}                                    
                                        name="dtfim"                                      
                                        defaultValue={dtfim}
                                        value={dtfim}
                                        onChange={date => { setdtfim(date) }}
                                        inputProps={{name:"dtfim", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                        className={errors.dtfim?"error":""}            
                                    />       
                                    {errors.dtfim && <FormHelperText className={classes.labelRootError}>
                                        <span> {errors.dtfim.message} </span>                                                                          
                                    </FormHelperText>} 
                                </FormControl>
                            </GridItem>
                            <GridItem xs={12} sm={6} md={2}>
                                <Button  round color="primary" 
                                    onClick={e => { handleClickPesquisa()}}>
                                    {t('label.search')}
                                </Button>
                            </GridItem>
                            {notification.show &&
                            <div>
                                <br/>
                                <SnackbarContent
                                    message={notification.message}
                                    color={notification.color}
                                    closeNotification={() => setNotification({show:false})}
                                    close
                                />
                            </div>}
                        </GridContainer>   

                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>

                {/* LISTA MIDIA x VENDA */}
                <GridContainer>            
                <GridItem xs={12}>
                    <Card>

                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>
                                {t('sidebar.media_sales')}
                            </h4>
                        </CardHeader>
                        
                        <CardBody>

                        {
                            dataCSV.length > 0 &&

                                <div>
                                    <div style={{float:'right'}}>
                                    <CsvDownloader
                                    filename="report"
                                    columns={columnsCSV}
                                    datas={dataCSV}
                                    separator={";"}>
                                        <Button  round color="default" size="sm" >CSV</Button> 
                                    </CsvDownloader>
                                    </div><div style={{clear:'both'}}></div>
                                </div>
                        }

                        <div style={{overflow:'auto',width:'100%'}}>
                            <div style={{minWidth:'1000px'}}>                               
                                    <ReactTable                  
                                    loading = {isLoadingList}
                                    data={list}
                                    filterable
                                    columns={columns}                                                  
                                    style={{height: "400px"}}
                                    showPagination={false}
                                    pageSize={list.length}
                                    minRows={5}
                                    className="-striped -highlight"
                                    previousText={t('button.previous')}
                                    nextText={t('button.next')}
                                    loadingText={t('label.loading')+"..."}
                                    noDataText={t('information_message.no_records_found')+"!"}
                                    pageText={t('label.page')}
                                    ofText={t('label.of')}
                                    rowsText={t('label.rows')}
                                />
                            </div>
                        </div>

                        </CardBody>
                    
                    </Card>
                </GridItem>
            </GridContainer>
        
        </div>
    
    );
}